<template>
    <div>
        <Head title="Create User"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link class="text-indigo-400 hover:text-indigo-600" :href="route('users.index')">Користувачі</Link>
            <span class="text-indigo-400 font-medium">/</span> Створити
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.first_name" :error="form.errors.first_name"
                                class="pb-8 pr-6 w-full lg:w-1/2" label="Ім'я"/>
                    <text-input v-model="form.last_name" :error="form.errors.last_name"
                                class="pb-8 pr-6 w-full lg:w-1/2" label="Прізвище"/>
                    <text-input v-model="form.phone_number" :error="form.errors.phone_number"
                                class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Телефон"/>
                    <select-input v-model="form.owner" :error="form.errors.owner" class="pb-8 pr-6 w-full lg:w-1/2"
                                  label="Адмін">
                        <option :value="true">Так</option>
                        <option :value="false">Ні</option>
                    </select-input>
                    <select-input v-model="form.watchman" :error="form.errors.watchman"
                                  class="pb-8 pr-6 w-full lg:w-1/2"
                                  label="Сторож">
                        <option :value="true">Так</option>
                        <option :value="false">Ні</option>
                    </select-input>
                    <select-input v-model="form.annual_subscription" :error="form.errors.annual_subscription"
                                  class="pb-8 pr-6 w-full lg:w-1/2"
                                  label="Річна підписка">
                        <option :value="true">Так</option>
                        <option :value="false">Ні</option>
                    </select-input>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">
                        Створити користувача
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import {route} from "ziggy-js";

export default {
    components: {
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
    },
    layout: Layout,
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                first_name: '',
                last_name: '',
                phone_number: '',
                owner: false,
                watchman: false,
                annual_subscription: false,
            }),
        }
    },
    methods: {
        route,
        store() {
            this.form.post(this.route('users.store'))
        },
    },
}
</script>
